import axios from "axios";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { SousGroupe } from "../../Models/Magasin/MagasinModels";
import { errorService } from "../Error/ErrorService";

export function SousGroupeService(){
    return{
        /**
         * Liste des centrales disponibles
         * Toutes les données sont pas exploités pour des questions d'optimisation
         * @param token 
         * @returns 
         */
        async getSousGroupesForAdmin(token:string):Promise<SousGroupe[]>{
            try {
                const response = await axios.get(`${URLAPI+'sousGroupes'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                let sousGroupes:SousGroupe[]=[];
                for(const element of data){
                    sousGroupes.push({
                        id:element['id'],
                        nom:element['nom'],
                        enseigne:element['enseigne'],
                        edited: false,
                        actif:true,
                        typeSousGroupe:element['typeSousGroupe'],
                        magasins:element['magasins'],
                    });
                }
                return sousGroupes;
            } catch (error) {
                console.log('erreur : ', error)
                return [];
            }
        },

        async getSousGroupesFromUrlsToPromiseToMagasin(urls:string[], token:string):Promise<SousGroupe[]>{
            let sousGroupes:SousGroupe[]=[];

            if(urls.length>0){
                for(const url of urls){
                    try {
                        const response = await axios.get(`${URL_MIDIS+url}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type":"application/ld+json"
                            },
                        });
                        const data = response.data['hydra:member'];
                        if(data.length>0){
                            sousGroupes.push({
                                id:data[0]['id'],
                                nom:data[0]['nom'],
                                magasins:undefined,//non nécessaire
                                enseigne:undefined,//non nécessaire ?? -> à verifier
                                edited: false,
                                actif:true,
                                typeSousGroupe:data[0]['typeSousGroupe']
                            });
                        }
                    } catch (error) {
                        errorService().handleError('Erreur lors du getSousGroupesFromUrlsToPromiseToMagasin', error)
                        return [];
                    }
                }
            }
            return sousGroupes;
        },

        async getSousGroupesFromUrlsToPromiseToEnseigne(urls:string[], token:string):Promise<SousGroupe[]>{
            let sousGroupes:SousGroupe[]=[];
            if(urls.length>0){
                for(const url of urls){
                    try {
                        const response = await axios.get(`${URL_MIDIS+url}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type":"application/ld+json"
                            },
                        });
                        const data = response.data['hydra:member'];
                        if(data.length>0){
                            sousGroupes.push({
                                id:data[0]['id'],
                                nom:data[0]['nom'],
                                magasins:data[0]['magasins'],
                                edited: false,
                                actif:true,
                                typeSousGroupe:data[0]['typeSousGroupe']
                            })
                        }
                    } catch (error) {
                        errorService().handleError('Erreur lors du getSousGroupesFromUrlsToPromiseToMagasin', error)
                        return [];
                    }
                }
            }
            return sousGroupes;
        },

        async postSousGroupe(nomSousGroupe:string, idEnseigne:number, token:any){
            const postObjectSousGroupe = {
                "nom": nomSousGroupe,
                "magasins": [],
                "enseigne": idEnseigne
            }
            const responsePOSTSousGroupe = await axios.post(
                `${URLAPI}sousGroupe`,
                postObjectSousGroupe,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return {status:responsePOSTSousGroupe.status, idResult:responsePOSTSousGroupe.data['id']};
        },

        async patchSousGroupe(sousGroupe:SousGroupe, token:any){
            const patchObjectSousGroupe = {
                "nom": sousGroupe.nom,
            }
            const responsePatchSousGroupe = await axios.patch(
                `${URLAPI}sousGroupe/${sousGroupe.id}`,
                patchObjectSousGroupe,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return responsePatchSousGroupe.status;
        },

        async deleteSousGroupe(idCentrale:number, token:any){
            //On s'assure de la suppression de l'idntifiant lié au magasin avant de supprimer le magasin
            const responseMagasin = await axios.delete(
            `${URLAPI}sousGroupe/${idCentrale}`,
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            );
            return responseMagasin.status;
        }
    }
}